export default {
  api: {
    login: '/console/api/admin/login',
    logout: '/console/api/admin/logout',
    recharge_list: '/console/api/accounting/recharge/list',
    order_list: '/console/api/accounting/order/list',
    machine: {
      instance_list: '/console/api/market/instance/list',
      instance_info: '/console/api/market/instance/info',
      machine_create: '/console/api/machine/resource/create',
      machine_edit: '/console/api/machine/resource/edit',
      machine_list: '/console/api/machine/resource/list',
      machine_info: '/console/api/machine/resource/info',
      machine_publish: '/console/api/machine/resource/publish',
      attribute_edit: '/console/api/machine/resource/attribute/edit',
    },
    user: {
      user_list: '/console/api/user/list',
      user_info: '/console/api/user/info',
      user_cert_list: '/console/api/user/cert/list',
      user_set_status: '/console/api/user/set/status',
      user_edit_data: '/console/api/user/edit',
      cert_set_status: '/console/api/user/set/auth_cert',
    },
    agent: {
      machine_attribute_sync: '/console/api/agent/machine/attributes/sync',
      machine_bind: '/console/api/agent/machine/bind',
      instance_create: '/console/api/agent/instance/create',
      instance_register: '/console/api/agent/instance/register',
      instance_info: '/console/api/agent/instance/info',
      instance_terminate: '/console/api/agent/instance/terminate',
      instance_remove: '/console/api/agent/instance/remove',
      instance_resume: '/console/api/agent/instance/resume',
      instance_pause: '/console/api/agent/instance/pause',
    },
    agent_call: {
      agent_call_create: '/console/api/agent/instance/call/create',
      agent_call_resume: '/console/api/agent/instance/call/resume',
      agent_call_stop: '/console/api/agent/instance/call/stop',
      agent_call_remove: '/console/api/agent/instance/call/remove',
    },
    shop: {
      shelf_list: '/console/api/shop/shelf/list',
      shelf_create: '/console/api/shop/shelf/create',
      shelf_machine_list: '/console/api/shop/shelf/machine/list',
      shelf_machine_add: '/console/api/shop/shelf/machine/add',
    },
  },
}
